import Link from 'next/link';
import Image from 'next/image';

const COMPANY = [
  { name: 'Home', href: '/' },
  {
    name: 'Partners',
    href: 'https://sites.google.com/player3.io/partnerprogram?usp=sharing',
  },
  { name: 'Merch Store', href: '/about' },
  { name: 'Blog', href: '/about' },
];

const RESOURCES = [
  { name: 'Help', href: 'mailto:hello@player3.io' },
  { name: 'Terms', href: '/terms-and-conditions/' },
  { name: 'Privacy', href: '/privacy-policy/' },
  { name: 'Cookies', href: '/about' },
];

const MEDIA = [
  { name: 'News', href: '/about' },
  { name: 'Press', href: '/about' },
];

const SOCIAL = [
  { name: 'YouTube', href: 'https://www.youtube.com/@Player3io' },
  { name: 'TikTok', href: 'https://www.tiktok.com/@player3.io' },
  { name: 'Instagram', href: 'https://www.instagram.com/player3.io/' },
  { name: 'Discord', href: 'https://discord.gg/7rxFGqSVTs' },
];

export const FooterHome = () => {
  return (
    <footer className="bg-black text-white md:pt-16 md:pb-10 pb-5 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex md:flex-row flex-col-reverse md:gap-28 gap-5">
          <Link href="/" className="md:mt-10">
            <Image
              priority
              width={265}
              height={44}
              src="/icons/logo-white.svg"
              alt="logo"
            />
          </Link>

          <div className="grid grid-cols-2 md:grid-cols-4 lg:gap-20 mb-16">
            <div className="mt-0">
              <h3 className="md:text-lg! text-sm! font-semibold md:mb-7 mb-4">
                Company
              </h3>
              <ul className="space-y-4 list-none px-0!">
                {COMPANY.map((item) => (
                  <li key={item.name}>
                    <Link
                      href={item.href}
                      target="_blank"
                      className="text-white hover:text-blue-primary md:text-2xl font-bold text-lg transition-colors"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-0">
              <h3 className="md:text-lg! text-sm! font-semibold md:mb-7 mb-4">
                Resources
              </h3>
              <ul className="space-y-4 list-none px-0!">
                {RESOURCES.map((item) => (
                  <li key={item.name}>
                    <Link
                      href={item.href}
                      target={item.name !== "Cookies" ? "_blank" : undefined}
                      className="text-white hover:text-blue-primary md:text-2xl font-bold text-lg  transition-colors"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-10 md:mt-0">
              <h3 className="md:text-lg! text-sm! font-semibold md:mb-7 mb-4">
                Media
              </h3>
              <ul className="space-y-4 list-none px-0!">
                {MEDIA.map((item) => (
                  <li key={item.name}>
                    <Link
                      href={item.href}
                      className="text-white hover:text-blue-primary md:text-2xl font-bold text-lg  transition-colors"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-10 md:mt-0">
              <h3 className="md:text-lg! text-sm! font-semibold md:mb-7 mb-4">
                Social
              </h3>
              <ul className="space-y-4 list-none px-0!">
                {SOCIAL.map((item) => (
                  <li key={item.name}>
                    <Link
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white hover:text-blue-primary md:text-2xl font-bold text-lg  transition-colors"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <p className="text-white text-base font-light mt-10 md:mt-0">
          ©Player³ 2026 | All rights reserved.
        </p>
      </div>
    </footer>
  );
};
